import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import axiosInstance from '../../axiosInstance.js';

export const ListquizcategorySlice = createAsyncThunk("listquizcategory",async (data, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get('listquizcategory');
      console.log(response)
        return response.data;
     
    } catch (error) {
      console.error("API error:", error);
      return rejectWithValue(error.response?.data || { message: "An error occurred" });
    }
  }
);

export const CreateQuizcategorySlice = createAsyncThunk("addquizcategory",async (data, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post('addquizcategory',data);
      console.log(response)
        return response.data;
     
    } catch (error) {
      console.error("API error:", error);
      return rejectWithValue(error.response?.data || { message: "An error occurred" });
    }
  }
);

export const UpdateQuizcategorySlice = createAsyncThunk("Updatequizcategory",async ({id,data}, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.patch(`updatequizcategory/${id}`,data);
      console.log(response)
        return response.data;
     
    } catch (error) {
      console.error("API error:", error);
      return rejectWithValue(error.response?.data || { message: "An error occurred" });
    }
  }
);

export const DeleteQuizcategorySlice = createAsyncThunk("deletecategory",async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.delete(`deletecategory/${id}`);
      console.log(response)
        return response.data;
     
    } catch (error) {
      console.error("API error:", error);
      return rejectWithValue(error.response?.data || { message: "An error occurred" });
    }
  }
);

const QuizCategorySlice = createSlice({
  name: 'Quiz Category',
  initialState: {
    AllQuizCategory: [],
    CreateQuizCategory:[],
    UpdateQuizCategory:[],
    DeleteQuizCategory:[],
    loading: false,
    error: null,
    validationErrors: [],
  },

  reducers: {},
  extraReducers: (builder) => {

    const handlePendingState = (state,action) => {
      state.loading = true;
      state.error = null; 
      state.validationErrors = []; 
    }
    const handleRejectState = (state, action) => {
      state.loading = false;
      state.error = action.payload?.message || "An error occurred";
      state.validationErrors = action.payload?.errors || []; 
      // toast.error(state.error);
    }

    builder
      .addCase(ListquizcategorySlice.pending,handlePendingState)
      .addCase(ListquizcategorySlice.fulfilled, (state, action) => {
        state.AllQuiz = action.payload.data; 
        state.loading = false;
        // toast.success("Logged Successfully!"); 
      })
      .addCase(ListquizcategorySlice.rejected,handleRejectState)

      .addCase(CreateQuizcategorySlice.pending,handlePendingState)
      .addCase(CreateQuizcategorySlice.fulfilled, (state, action) => {
        state.CreateQuizCategory = action.payload.data; 
        state.loading = false;
        toast.success("Quiz category created successfully!"); 
      })
      .addCase(CreateQuizcategorySlice.rejected,handleRejectState)

      .addCase(UpdateQuizcategorySlice.pending,handlePendingState)
      .addCase(UpdateQuizcategorySlice.fulfilled, (state, action) => {
        state.UpdateQuizCategory = action.payload.data; 
        state.loading = false;
        toast.success("Quiz category created successfully!"); 
      })
      .addCase(UpdateQuizcategorySlice.rejected,handleRejectState)

      .addCase(DeleteQuizcategorySlice.pending,handlePendingState)
      .addCase(DeleteQuizcategorySlice.fulfilled, (state, action) => {
        state.DeleteQuizCategory = action.payload.data; 
        state.loading = false;
        toast.success("Quiz category created successfully!"); 
      })
      .addCase(DeleteQuizcategorySlice.rejected,handleRejectState)
  },
});

export default QuizCategorySlice.reducer;
